import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';

import preview from './capsuleContainerPreview.png';

export const capsuleContainerDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Capsule Container widget acts as a container for Capsule
                widgets
            </div>
        </>
    ),
    previews: [
        {
            src: preview,
            altText: 'capsule-container-preview',
        },
    ],
};
